import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('hotelAdminToken');
  const domain = window.location.hostname;

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  config.headers['X-Hotel-Domain'] = domain;

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('hotelAdminToken');
      localStorage.removeItem('hotelAdminUser');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
